import { bannerGenerator } from './generators/banners';
import { productsListGenerator } from './generators/productsList';

export const GtmDataAttributesGenerator = {
  banner: bannerGenerator,
  productsList: productsListGenerator,
};
